import { render, staticRenderFns } from "./Universities.vue?vue&type=template&id=7e7299de"
import script from "./Universities.vue?vue&type=script&lang=js"
export * from "./Universities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports